import React, { PureComponent } from 'react';
import { Route, Switch } from 'react-router-dom';

import ShippingCostList from 'containers/Dashboard/ShippingCost/ShippingCostList';
import ShippingCostNew from 'containers/Dashboard/ShippingCost/ShippingCostNew';

class ShippingCost extends PureComponent {
  render() {
    return (
      <Switch>
        <Route exact path="/dashboard/shippingcost" component={ShippingCostList} />
        <Route
          exact
          path={['/dashboard/shippingcost/new', '/dashboard/shippingcost/:id']}
          component={ShippingCostNew}
        />
      </Switch>
    );
  }
}

export default ShippingCost;
